var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.18182 25H22.0909M21.5472 19.4327L24.4741 7.19807C24.6761 6.35382 23.7803 5.67084 23.0197 6.08918L18.5492 8.54793C18.087 8.80214 17.5068 8.65362 17.2236 8.20859L13.5463 2.42992C13.1375 1.78753 12.1894 1.81949 11.8248 2.48795L8.75326 8.11903C8.48814 8.60508 7.87856 8.78321 7.39344 8.51639L2.98033 6.08918C2.21971 5.67084 1.32388 6.35382 1.52585 7.19807L4.45279 19.4327C4.56044 19.8826 4.96269 20.2 5.42535 20.2H20.5747C21.0373 20.2 21.4396 19.8826 21.5472 19.4327Z",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.891bfb19b1646e75de9860590ffd0f41.svg";
export { ForwardRef as ReactComponent };